window.bundleDataB = {
"Beatrice-girl": {
displayName: "Beatrice",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Beatrice Personalized Coloring Experience",
variantId: "49929702113517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beatrice_final_cover.png?v=1777863211",
price: "$14.99",
preorder: true
},
{
title: "Beatrice Unicorn Holographic Sticker",
variantId: "49933745520877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beatrice_holographic_sticker.png?v=1779337726",
price: "$4.99",
preorder: false
},
{
title: "Beatrice Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Beau-boy": {
displayName: "Beau",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Beau Personalized Coloring Experience",
variantId: "49709386367213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beau_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Beau Dragon Holographic Sticker",
variantId: "49933753778413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beauholographicsticker.png?v=1779337892",
price: "$4.99",
preorder: false
},
{
title: "Beau Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Beckett-boy": {
displayName: "Beckett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Beckett Personalized Coloring Experience",
variantId: "49279558615277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beckett_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Beckett Dragon Holographic Sticker",
variantId: "49933778714861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beckettholographicsticker.png?v=1779338149",
price: "$4.99",
preorder: false
},
{
title: "Beckett Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Bella-girl": {
displayName: "Bella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bella Personalized Coloring Experience",
variantId: "49279558713581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bella_final_cover.png?v=1773684205",
price: "$14.99",
preorder: true
},
{
title: "Bella Unicorn Holographic Sticker",
variantId: "49933778682093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bellaholographicsticker.png?v=1779338315",
price: "$4.99",
preorder: false
},
{
title: "Bella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Benjamin-boy": {
displayName: "Benjamin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Benjamin Personalized Coloring Experience",
variantId: "49279558811885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Benjamin_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Benjamin Dragon Holographic Sticker",
variantId: "49933778649325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Benjaminholographicsticker.png?v=1779338527",
price: "$4.99",
preorder: false
},
{
title: "Benjamin Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Bennett-boy": {
displayName: "Bennett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bennett Personalized Coloring Experience",
variantId: "49472182124781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bennett_final_cover.png?v=1772930021",
price: "$14.99",
preorder: true
},
{
title: "Bennett Dragon Holographic Sticker",
variantId: "49933759021293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bennettholographicsticker.png?v=1779339112",
price: "$4.99",
preorder: false
},
{
title: "Bennett Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Blair-girl": {
displayName: "Blair",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Blair Personalized Coloring Experience",
variantId: "49402684899565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/BLAIRFINALCOVER.png?v=1771819041",
price: "$14.99",
preorder: true
},
{
title: "Blair Unicorn Holographic Sticker",
variantId: "49933768163565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Blairholographicsticker.png?v=1779339389",
price: "$4.99",
preorder: false
},
{
title: "Blair Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Blake-girl": {
displayName: "Blake",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Blake Personalized Coloring Experience",
variantId: "49274729496813",
image: "https://lkbunting.com/cdn/shop/files/Blake_final_cover_51fc7d66-ac46-4550-9c98-0ce096cc4395.png?v=1775415295&width=600",
price: "$14.99",
preorder: true
},
{
title: "Blake Unicorn Holographic Sticker",
variantId: "49998471332077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Blakeholographicsticker.png?v=1779339860",
price: "$4.99",
preorder: false
},
{
title: "Blake Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Blake-boy": {
displayName: "Blake",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Blake Personalized Coloring Experience",
variantId: "49774111523053",
image: "https://lkbunting.com/cdn/shop/files/Blake_final_cover.png?v=1772243801&width=600",
price: "$14.99",
preorder: true
},
{
title: "Blake Dragon Holographic Sticker",
variantId: "49998470807789",
image: "https://lkbunting.com/cdn/shop/files/Blakeboyholographicsticker.png?v=1779339595&width=600",
price: "$4.99",
preorder: false
},
{
title: "Blake Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Blythe-girl": {
displayName: "Blythe",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Blythe Personalized Coloring Experience",
variantId: "49274296303853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Blythe_final_cover.png?v=1773719955",
price: "$14.99",
preorder: true
},
{
title: "Blythe Unicorn Holographic Sticker",
variantId: "49933780910317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Blytheholographicsticker.png?v=1779340083",
price: "$4.99",
preorder: false
},
{
title: "Blythe Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Bob-boy": {
displayName: "Bob",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bob Personalized Coloring Experience",
variantId: "49279559008493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bob_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Bob Dragon Holographic Sticker",
variantId: "49933778583789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bobholographicsticker.png?v=1779340252",
price: "$4.99",
preorder: false
},
{
title: "Bob Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Bonnie-girl": {
displayName: "Bonnie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bonnie Personalized Coloring Experience",
variantId: "49279559106797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bonnie_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Bonnie Unicorn Holographic Sticker",
variantId: "49933778551021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bonnieholographicsticker.png?v=1779340411",
price: "$4.99",
preorder: false
},
{
title: "Bonnie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Brandan-boy": {
displayName: "Brandan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brandan Personalized Coloring Experience",
variantId: "49657641861357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brandan_final_cover.png?v=1773501513",
price: "$14.99",
preorder: true
},
{
title: "Brandan Dragon Holographic Sticker",
variantId: "49933754564845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brandanholographicsticker.png?v=1779340573",
price: "$4.99",
preorder: false
},
{
title: "Brandan Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Brandon-boy": {
displayName: "Brandon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brandon Personalized Coloring Experience",
variantId: "49279559205101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brandon_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Brandon Dragon Holographic Sticker",
variantId: "49933778518253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brandonholographicsticker.png?v=1779340770",
price: "$4.99",
preorder: false
},
{
title: "Brandon Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Braxton-boy": {
displayName: "Braxton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Braxton Personalized Coloring Experience",
variantId: "49279559237869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Braxton_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Braxton Dragon Holographic Sticker",
variantId: "49933778485485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Braxtonholographicsticker.png?v=1779340916",
price: "$4.99",
preorder: false
},
{
title: "Braxton Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Brayden-boy": {
displayName: "Brayden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brayden Personalized Coloring Experience",
variantId: "49339394654445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Braydenfinalcover.png?v=1771691975",
price: "$14.99",
preorder: true
},
{
title: "Brayden Dragon Holographic Sticker",
variantId: "49933772161261",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Braydenholographicsticker.png?v=1779341100",
price: "$4.99",
preorder: false
},
{
title: "Brayden Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Brett-boy": {
displayName: "Brett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brett Personalized Coloring Experience",
variantId: "49400118116589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brett_final_cover.png?v=1771691582",
price: "$14.99",
preorder: true
},
{
title: "Brett Dragon Holographic Sticker",
variantId: "49933770096877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brettholographicsticker.png?v=1779341274",
price: "$4.99",
preorder: false
},
{
title: "Brett Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Brian-boy": {
displayName: "Brian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brian Personalized Coloring Experience",
variantId: "49279559368941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brian_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Brian Dragon Holographic Sticker",
variantId: "49933778419949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brianholographicsticker.png?v=1779341347",
price: "$4.99",
preorder: false
},
{
title: "Brian Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Brianna-girl": {
displayName: "Brianna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brianna Personalized Coloring Experience",
variantId: "49279559434477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brianna_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Brianna Unicorn Holographic Sticker",
variantId: "49933778387181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briannaholographicsticker.png?v=1779341503",
price: "$4.99",
preorder: false
},
{
title: "Brianna Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Bridget-girl": {
displayName: "Bridget",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bridget Personalized Coloring Experience",
variantId: "49801325871341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bridget_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Bridget Unicorn Holographic Sticker",
variantId: "49933752631533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bridgetholographicsticker.png?v=1779341650",
price: "$4.99",
preorder: false
},
{
title: "Bridget Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Briele-girl": {
displayName: "Briele",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Briele Personalized Coloring Experience",
variantId: "49929650700525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briele_final_cover.png?v=1777857547",
price: "$14.99",
preorder: true
},
{
title: "Briele Unicorn Holographic Sticker",
variantId: "49933745848557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brieleholographicsticker.png?v=1779341801",
price: "$4.99",
preorder: false
},
{
title: "Briele Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Briell-girl": {
displayName: "Briell",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Briell Personalized Coloring Experience",
variantId: "49929649979629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briell_final_cover.png?v=1777857546",
price: "$14.99",
preorder: true
},
{
title: "Briell Unicorn Holographic Sticker",
variantId: "49933745881325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briellholographicsticker.png?v=1779341951",
price: "$4.99",
preorder: false
},
{
title: "Briell Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Briella-girl": {
displayName: "Briella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Briella Personalized Coloring Experience",
variantId: "49929644966125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briella_final_cover.png?v=1777857547",
price: "$14.99",
preorder: true
},
{
title: "Briella Unicorn Holographic Sticker",
variantId: "49933745946861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briellaholographicsticker.png?v=1779342131",
price: "$4.99",
preorder: false
},
{
title: "Briella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Briellee-girl": {
displayName: "Briellee",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Briellee Personalized Coloring Experience",
variantId: "49929648734445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briellee_final_cover.png?v=1777857548",
price: "$14.99",
preorder: true
},
{
title: "Briellee Unicorn Holographic Sticker",
variantId: "49933745914093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brielleeholographicsticker.png?v=1779342356",
price: "$4.99",
preorder: false
},
{
title: "Briellee Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Brittany-girl": {
displayName: "Brittany",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brittany Personalized Coloring Experience",
variantId: "49263857303789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brittany_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Brittany Unicorn Holographic Sticker",
variantId: "49933781860589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brittany_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Brittany Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Brooke-girl": {
displayName: "Brooke",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brooke Personalized Coloring Experience",
variantId: "49279559467245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brooke_final_cover.png?v=1773719956",
price: "$14.99",
preorder: true
},
{
title: "Brooke Unicorn Holographic Sticker",
variantId: "49933778354413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brooke_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "Brooke Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Brooklyn-girl": {
displayName: "Brooklyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brooklyn Personalized Coloring Experience",
variantId: "49279559631085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brooklyn_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Brooklyn Unicorn Holographic Sticker",
variantId: "49933778321645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brooklyn_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Brooklyn Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Brooks-boy": {
displayName: "Brooks",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brooks Personalized Coloring Experience",
variantId: "49279559696621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brooks_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Brooks Dragon Holographic Sticker",
variantId: "49933778288877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brooks_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Brooks Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Bryan-boy": {
displayName: "Bryan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bryan Personalized Coloring Experience",
variantId: "49339401797869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bryan_final_cover.png?v=1772243802",
price: "$14.99",
preorder: true
},
{
title: "Bryan Dragon Holographic Sticker",
variantId: "49933772128493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bryan_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "Bryan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Bryelle-girl": {
displayName: "Bryelle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bryelle Personalized Coloring Experience",
variantId: "49929652830445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bryelle_final_cover.png?v=1777857547",
price: "$14.99",
preorder: true
},
{
title: "Bryelle Unicorn Holographic Sticker",
variantId: "49933745815789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bryelle_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Bryelle Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Brynn-girl": {
displayName: "Brynn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brynn Personalized Coloring Experience",
variantId: "49774111949037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brynn_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Brynn Unicorn Holographic Sticker",
variantId: "49933752795373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brynn_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Brynn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Brielle-girl": {
displayName: "Brielle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brielle Personalized Coloring Experience",
variantId: "50078193189101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brielle_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Brielle Unicorn Holographic Sticker",
variantId: "50077627121901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Briellestickerwebsite.png?v=1780809158",
price: "$4.99",
preorder: false
},
{
title: "Brielle Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Bryson-boy": {
displayName: "Bryson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bryson Personalized Coloring Experience",
variantId: "50126115045613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bryson_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Bryson Dragon Holographic Sticker",
variantId: "50127068102893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brysonstickerwebsite.png?v=1781967410",
price: "$4.99",
preorder: false
},
{
title: "Bryson Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Brody-boy": {
displayName: "Brody",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brody Personalized Coloring Experience",
variantId: "50180868079853",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brody_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Brody Dragon Holographic Sticker",
variantId: "50180769841389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brodywebsitesticker.png?v=1782609861",
price: "$4.99",
preorder: false
},
{
title: "Brody Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Barrett-boy": {
displayName: "Barrett",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Barrett Personalized Coloring Experience",
variantId: "50180865917165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Barrett_final_cover.png?v=1782611299",
price: "$14.99",
preorder: true
},
{
title: "Barrett Dragon Holographic Sticker",
variantId: "50180814012653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Barrettwebsitesticker.png?v=1782610616",
price: "$4.99",
preorder: false
},
{
title: "Barrett Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Blakely-girl": {
displayName: "Blakely",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Blakely Personalized Coloring Experience",
variantId: "50245737414893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Blakely_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Blakely Unicorn Holographic Sticker",
variantId: "50260024525037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Blakely_holographic_sticker.png?v=1783785472",
price: "$4.99",
preorder: false
},
{
title: "Blakely Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Bailey-girl": {
displayName: "Bailey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bailey Personalized Coloring Experience",
variantId: "50274196291821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bailey_final_cover.png?v=1783795016",
price: "$14.99",
preorder: true
},
{
title: "Bailey Unicorn Holographic Sticker",
variantId: "50274685747437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Baileyholographicsticker.png?v=1783828469",
price: "$4.99",
preorder: false
},
{
title: "Bailey Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Beckham-boy": {
displayName: "Beckham",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Beckham Personalized Coloring Experience",
variantId: "50399324373229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beckham_final_cover.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Beckham Dragon Holographic Sticker",
variantId: "50399519310061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Beckham_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Beckham Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Bryce-boy": {
displayName: "Bryce",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Bryce Personalized Coloring Experience",
variantId: "50399782830317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brycefinalcover.png?v=1785904758",
price: "$14.99",
preorder: true
},
{
title: "Bryce Dragon Holographic Sticker",
variantId: "50449544446189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Bryce_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Bryce Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Brynlee-girl": {
displayName: "Brynlee",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Brynlee Personalized Coloring Experience",
variantId: "50519281860845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brynlee_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Brynlee Unicorn Holographic Sticker",
variantId: "50497554809069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Brynlee_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Brynlee Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 






};